import { BaseModel } from './base-model.interface';
import { NotificationInitVariables } from '../template/notifications-model.interface';
import BlockModel from './block-model.interface';

export interface ZigZagNoHeadingNoButtonModel extends BaseModel {
  variables?: { [key: string]: string } | ZigZagNoHeadingNoButtonVariables;
}

export interface ZigZagNoHeadingNoButtonVariables {
  ZigZagNhnbImage: string;
  ZigZagNhnbImageHref: string;
  ZigZagNhnbImageAlt: string;
  ZigZagNhnbText: string;
  ZigZagNhnbImageHrefSegmentRegex: string;
}

export class ZigZagNoHeadingNoButtonInitVariables implements ZigZagNoHeadingNoButtonVariables {
  ZigZagNhnbImage = '';
  ZigZagNhnbImageHref = '';
  ZigZagNhnbImageAlt = '';
  ZigZagNhnbText = '';
  ZigZagNhnbImageHrefSegmentRegex = '';
}

export class ZigZagNoHeadingNoButtonInitModel implements BlockModel {
  blockId: string = '';
  count: number = 0;
  name: string = '';
  variables: { [key: string]: string };
  notifications: NotificationInitVariables[];

  constructor() {
    const initVars = new ZigZagNoHeadingNoButtonInitVariables();
    this.variables = { ...initVars };
    this.notifications = [new NotificationInitVariables()];
  }
}

